import {
  issueInvoicePageViewList,
  KHHDON_LAST,
} from "pages/IssueInvoice/utils";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListData from "./ListData";

const ListInvoiceWareHousesAgency = () => {
  const [filterList, setFilterList] = useState({});
  const [khhdonDefault, setKhhdonDefault] = useState(null);
  const [pageView, setPageView] = useState(null);

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
      let curYear = new Date().getFullYear().toString();
      curYear = curYear?.substr(curYear.length - 2);
      switch (finalBuInfo?.invoice_type) {
        case 1:
          setKhhdonDefault(`C${curYear}${KHHDON_LAST.WAREHOUSE_AGENCY}`);
          setPageView(issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE);
          break;
        case 0:
          setKhhdonDefault(`K${curYear}${KHHDON_LAST.WAREHOUSE_AGENCY}`);
          setPageView(issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE);
          break;
        default:
          break;
      }
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListData
        filterList={filterList}
        title={"PHIẾU XUẤT KHO GỬI BÁN ĐẠI LÝ"}
        titleManger={"Hóa đơn khác"}
        khhdonDefault={khhdonDefault}
        pageView={pageView}
      />
    </React.Fragment>
  );
};

export default ListInvoiceWareHousesAgency;
